
// additional suing translations, keeping separate from translations-*.ts in case those are updated in sui
export const TRANSLATIONS_SUING_TH = {
  report: {
    downloadExcelWorkbook: 'ดาวน์โหลดเป็นไฟล์  Excel Workbook (.xlsx)'
  }
}
